import { render, staticRenderFns } from "./ModalRemovePassCode.vue?vue&type=template&id=6ea8566a&scoped=true&"
import script from "./ModalRemovePassCode.vue?vue&type=script&lang=ts&"
export * from "./ModalRemovePassCode.vue?vue&type=script&lang=ts&"
import style0 from "./ModalRemovePassCode.vue?vue&type=style&index=0&id=6ea8566a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea8566a",
  null
  
)

export default component.exports